import React from 'react';
import { Map } from 'react-openlayers';
import Layers from './component/Layers';

class App extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      projection: 'EPSG:3575',
      center: [-191037, -2766770],
      zoom: 7,
      projDefs: [
        {
          epsg: 'EPSG:3575',
          def:
            '+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs'
        }
      ]
    };
  }

  render () {
    const { projection, center, zoom, projDefs } = this.state;
    return (
      <div className='map-layout--root'>
        <Map
          center={center}
          zoom={zoom}
          minZoom={1}
          maxZoom={18}
          projection={projection}
          projDefs={projDefs}
        >
          {[<Layers key='layers' />]}
        </Map>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js